export const DELEGATION = {
  DELEGATIONS: 'DELEGATIONS',
  DELEGATION_VICE_TO: 'DELEGATION_VICE_TO',
  DELEGATION_VICE_FROM: 'DELEGATION_VICE_FROM',
  DELEGATION_VICE_ALL: 'DELEGATION_VICE_ALL',
};
